import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    audioPlaying: false,
  },
  mutations: {
    chAudioPlaying(state, audioPlaying) {
      state.audioPlaying = audioPlaying;
    },
  },
  actions: {
    chAudioPlaying: ({ commit }, audioPlaying) => {
      commit('chAudioPlaying', audioPlaying);
    },
  },
  getters: {
    // getTitle: state => state.title,
  },
});
